import { defineAsyncComponent } from "vue";
import ROLE from "@configs/role.ts";
import { ROUTE_ACCESS } from "@plugins/router/router.const.ts";

export default [
  {
    name: "MyDriveHome",
    component: defineAsyncComponent(() => import("@modules/my-drive/components/MyDrive.vue")),
    meta: {
      tab: "my-drive",
      access: ROUTE_ACCESS.AUTHENTICATED,
      role: [ROLE.TEACHER, ROLE.STUDENT],
    },
    path: "/my-drive/folder/view/:folderUuid?",
    props: (route) => ({ folderUuid: route.params.folderUuid, keyword: route.query.keyword }),
  },
  {
    name: "MyDriveSharedWithMe",
    component: defineAsyncComponent(
      () => import("@modules/my-drive/components/MyDriveSharedWithMe.vue"),
    ),
    meta: { tab: "shared-with-me", access: ROUTE_ACCESS.AUTHENTICATED, role: [ROLE.TEACHER] },
    path: "/my-drive/shared-with-me",
    props: (route) => ({ keyword: route.query.keyword }),
  },
  {
    name: "MyDriveTrash",
    component: defineAsyncComponent(() => import("@modules/my-drive/components/MyDriveTrash.vue")),
    meta: { tab: "trash", access: ROUTE_ACCESS.AUTHENTICATED, role: [ROLE.TEACHER, ROLE.STUDENT] },
    path: "/my-drive/trash",
    props: (route) => ({ keyword: route.query.keyword }),
  },
];
